import { ContainerModule } from 'inversify';
import { ExamStateMachine } from './state-machine';

export const examPlayerModule = new ContainerModule((bind) => {
  bind(ExamStateMachine).toSelf()
});
